var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticStyle:{"z-index":"1000"},attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"size":70,"width":4,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }